import React from "react";
import { observer } from "mobx-react";
import { WorkAuthorPublisherViewStore } from "../../store";
import { WorkAuthorPublisherViewForm } from "./WorkAuthorPublisherViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type WorkAuthorPublisherViewProps = {
  workAuthorPublisherViewStore: WorkAuthorPublisherViewStore;
};

export const WorkAuthorPublisherView: React.FC<WorkAuthorPublisherViewProps> =
  observer(({ workAuthorPublisherViewStore }) => {
    return (
      <div>
        <WorkAuthorPublisherViewForm
          publisherValue={workAuthorPublisherViewStore.publisherValue}
          percentage={workAuthorPublisherViewStore.percentageValue}
          durationInYears={workAuthorPublisherViewStore.durationInYearsValue}
          autoRenewalYears={workAuthorPublisherViewStore.autoRenewalYearsValue}
          onPrint={(handlePrint: () => void) =>
            workAuthorPublisherViewStore.printWorkAuthorPublisher(handlePrint)
          }
          onCancel={() =>
            workAuthorPublisherViewStore.cancelWorkAuthorPublisher()
          }
          onEdit={
            workAuthorPublisherViewStore.isEditEnabled
              ? () => workAuthorPublisherViewStore.editWorkAuthorPublisher()
              : undefined
          }
        />
        <ErrorDialog
          open={workAuthorPublisherViewStore.errorDialogOpened}
          title={workAuthorPublisherViewStore.errorTitle}
          description={workAuthorPublisherViewStore.errorDescription}
          onClose={() => workAuthorPublisherViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
